import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { AuthService } from '@/services/auth.service'
import { useAuthStore } from '@/store/auth.store'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: to => {
      return AuthService.getToken() ? '/home' : '/login'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cash-collection',
    name: 'CashCollectionGameGroup',
    component: () => import('../views/cash-collection/GameGroupView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-monitoring/online-details',
    name: 'onlineDetails',
    component: () => import('../views/sales-monitoring/OnlineDetailsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-monitoring/draw-result',
    name: 'drawResult',
    component: () => import('../views/sales-monitoring/DrawResultView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-monitoring/sales-limit',
    name: 'salesLimit',
    component: () => import('../views/sales-monitoring/SalesLimitView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/back-office/terminals',
    name: 'terminals',
    component: () => import('../views/back-office/TerminalsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/back-office/parameters',
    name: 'parameters',
    component: () => import('../views/back-office/ParametersView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/accounting/pa-receipt',
    name: 'paReceipt',
    component: () => import('../views/accounting/PAReceiptView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/accounting/pa-ledger',
    name: 'paLedger',
    component: () => import('../views/accounting/PALedgerView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password',
    name: 'changePassword',
    component: () => import('../views/ChangePasswordView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: { requiresAuth: true },
    beforeEnter: (to: any, from: any, next: any) => {
      const authStore = useAuthStore()
      if (authStore.currentUser?.user_type_id === 1) {
        next('/home') // Redirect admins to home
      } else {
        next()
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = AuthService.getToken()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isPublic = to.matched.some(record => record.meta.public)

  if (to.path === '/' && isAuthenticated) {
    next('/home')
  } else if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (isAuthenticated && isPublic) {
    next('/home')
  } else {
    next()
  }
})

export default router
